import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f39a180&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f39a180&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4f39a180&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../ui/comic_ai/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39a180",
  null
  
)

export default component.exports